import { render, staticRenderFns } from "./vistadeorden.vue?vue&type=template&id=ac00d4f2&"
import script from "./vistadeorden.vue?vue&type=script&lang=js&"
export * from "./vistadeorden.vue?vue&type=script&lang=js&"
import style0 from "./vistadeorden.vue?vue&type=style&index=0&id=ac00d4f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports